
import { Routes, Route } from 'react-router'
import ListIsumosView from './views/ListIsumosView'
import CreateUpdateInsumoView from './views/CreateUpdateInsumoView'
export default function InsumoRouter() {
    return (
        <Routes>
            <Route path="/" element={<ListIsumosView />} />
            <Route path="/crear" element={<CreateUpdateInsumoView />} />
            <Route path="/editar/:hash" element={<CreateUpdateInsumoView />} />
        </Routes>
    )
}